import styled from "styled-components";

export const MyMessageErro = styled.span`
  font-size: 12px;
  color: ${(props) => props.theme.colors.red};
  margin-top: 6px;
`;
